import { render, staticRenderFns } from "./BirthdaysMyBirthdays.vue?vue&type=template&id=94eba034&scoped=true&"
import script from "./BirthdaysMyBirthdays.vue?vue&type=script&lang=ts&"
export * from "./BirthdaysMyBirthdays.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94eba034",
  null
  
)

export default component.exports